export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hallo!✨"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heb je een vraag of zin in een goed gesprek? We staan voor je klaar!"])}
  },
  "conversation": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Huidige conversaties"])},
    "last_message_empty_caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nieuwe conversatie..."])},
    "welcome_text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Welkom bij ", _interpolate(_named("messengerName")), "."])},
    "enter_message_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vul hieronder uw vraag in, zodat we uw vraag snel kunnen beantwoorden."])},
    "compose": {
      "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schrijf een bericht..."])}
    },
    "survey": {
      "post": {
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We horen graag wat je van het gesprek vond:"])},
        "thank_you_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedankt voor het beoordelen van de conversatie!"])}
      }
    },
    "status": {
      "sending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aan het verzenden..."])},
      "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verzonden"])},
      "conversation_is_closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversatie is afgesloten"])}
    },
    "errors": {
      "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversatie kan niet geladen worden."])}
    }
  },
  "archived_conversations": {
    "header": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gearchiveerde gesprekken (", _interpolate(_named("count")), ")"])}
  },
  "search": {
    "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoek binnen het helpcenter..."])},
    "no_results": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Geen resultaten gevonden voor \"", _interpolate(_named("query")), "\""])},
    "no_results_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Probeer andere zoekwoorden of vul je volledige vraag in"])}
  },
  "channels": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Huidige conversaties"])},
    "whatsapp": {
      "card_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verstuur een WhatsApp-bericht"])},
      "qr_code_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan met je camera app of klik op de QR-code om de conversatie te starten."])},
      "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WhatsApp openen"])},
      "number_undefined_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nummer niet ingesteld"])},
      "initial_text_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hi team! Kunnen jullie mij helpen? Ik..."])}
    }
  },
  "agents": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "availability": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ons support team is bereikbaar via de chat."])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "status": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offline"])},
      "away": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niet beschikbaar"])}
    },
    "is_typing": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("agentName")), " is aan het typen..."])}
  },
  "forms": {
    "fields": {
      "_CONTACT_NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naam"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_CONTACT_EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailadres"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_CONTACT_PHONE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefoon"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(bijv. 0612345678)"])}
      },
      "_SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onderwerp"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_INITIAL_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Je vraag"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Je bericht"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    },
    "types": {
      "PRE_CHAT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vul hieronder je gegevens in zodat we weten wie je bent!😄"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verstuur je bericht"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedankt voor het invullen van je gegevens. We koppelen je aan een van onze teamleden!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hmm, de conversatie kon niet worden gestart. Kan je het opnieuw proberen?"])}
      },
      "CONTACT_DETAILS": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vul het formulier hieronder om in contact te blijven"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Versturen"])},
        "dismiss-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niet nu"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dank je wel voor het invullen van jouw e-mailadres."])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oeps, het is niet gelukt om het formulier te versturen."])}
      },
      "EMAIL": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stuur ons een bericht"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vul het formulier hieronder in om in contact te komen met ons support-team"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verstuur je bericht"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Het bericht is verstuurd!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oeps, het is niet gelukt om het bericht te versturen. Kan je het opnieuw proberen?"])}
      },
      "WHATSAPP_CONTACT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start een gesprek via WhatsApp"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vul je gegevens en je vraag in en dan helpen we je zo snel mogelijk!"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start het gesprek"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Het bericht is verstuurd!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oeps, het is niet gelukt om het bericht te versturen. Kan je het opnieuw proberen?"])}
      }
    }
  },
  "mailform": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailformulier"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vul het formulier in en dan helpen we je snel!😄"])},
    "fields": {
      "NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naam"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subject"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "QUESTION": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Question"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "UPLOAD": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "add_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestand toevoegen"])}
      },
      "TOPIC": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onderwerp"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    },
    "notifications": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Het bericht is verstuurd!"])},
      "errors": {
        "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Het is helaas niet gelukt om het bericht te versturen. Kan je het opnieuw proberen? "])}
      }
    },
    "submit_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verstuur je bericht"])}
  },
  "common": {
    "buttons": {
      "start_new_conversation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start nieuwe conversatie"])},
      "show_archived_conversations": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Toon gearchiveerde conversaties (", _interpolate(_named("count")), ")"])},
      "go_to_mailform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verstuur een e-mail"])},
      "go_back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terug"])}
    },
    "page_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["💬 Nieuw bericht: \"", _interpolate(_named("message")), "\""])},
    "toast": {
      "generic_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oeps, er gaat iets mis!"])},
      "message_sent_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is een fout opgetreden tijdens het verzenden van het bericht"])},
      "giphy_no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen Giphy afbeelding gevonden"])}
    },
    "errors": {
      "upload_too_large": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De bestandsgrootte mag niet groter zijn dan 5 MB"])},
      "upload_file_type_disallowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dit bestandstype is niet toegestaan"])}
    }
  },
  "gdpr": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toestemming AVG"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hi! We gaan graag met je in gesprek. Maar volgens de Algemene verordening gegevensbescherming van de EU hebben we eerst je goedkeuring nodig om je persoonlijke informatie te gebruiken (zoals je naam en e-mailadres). Vind je het goed als:<br><br>1) We je persoonlijke informatie bewaren zodat we het gesprek later kunnen hervatten;<br><br>2) We je e-mails kunnen sturen om ons gesprek op te volgen;<br><br>(3) We je e-mails kunnen sturen over onze aankomende services en promoties.<br>"])},
    "disapprove_body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen probleem. Je kan de voorwaarden en privacy op elk moment bekijken en toestemming geven om met ons in contact te komen!"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ja, geen probleem"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nee, liever niet"])}
  },
  "powered_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powered by Grasp"])}
}